import React, { useEffect, useRef } from "react";
import { getStep6Data } from "../../helper";
import StatsCard from "../../../../../Components/StatsCard";
import { LifeScoreCard } from "../../../../../Components/PowerScoreStat/LifeScoreCard";
import useUserStore from "../../../../../zustand-stores/UserStore";
import { LevelUpImage } from "../../../../../Components/LevelUpImage";

export const Step8 = ({ warmapQuestionResponse = {} }) => {
  const step6Data = getStep6Data(warmapQuestionResponse);
  const { user } = useUserStore();
  const getIcon = (key) => {
    switch (key) {
      case "power_score":
        return "/icons/power-score.svg";
      case "habits":
        return "/icons/habits-icon.svg";
      // ... (rest of getIcon function)
      case "journal":
        return "/icons/journal-icon.svg";
      case "user_goals":
        return "/icons/goal-icon.svg";
      case "tasks":
        return "/icons/note1.svg";
      case "war_map":
        return "/icons/calender-icon.svg";
      case "game":
        return "/icons/games-icon.svg";
      default:
        return "/icons/power-score.svg";
    }
  };

  const getLabel = (key) => {
    if (!key) return "";
    const spacedKey = key.replace(/_/g, " ");
    const capitalizedLabel =
      spacedKey.charAt(0).toUpperCase() + spacedKey.slice(1);

    return capitalizedLabel;
  };

  const getAverageScoreLabel = (key) => {
    if (!key) return "";
    const spacedKey = key.replace(/_/g, " ");
    let capitalizedLabel =
      spacedKey.charAt(0).toUpperCase() + spacedKey.slice(1);
    const lastWord = capitalizedLabel.split(" ").pop();
    if (lastWord === "average") {
      capitalizedLabel = capitalizedLabel.replace(lastWord, "");
    }

    return capitalizedLabel;
  };

  const getTrendProps = (value) => ({
    trendIcon:
      value >= 0
        ? "/icons/graph-score-increase.svg"
        : "/icons/graph-score-decrease.svg",
    chartIcon:
      value >= 0
        ? "/icons/assesssment-chart-increase.svg"
        : "/icons/assessment-chart-decrease.svg",
    percentageColor: value >= 0 ? "#5ce0a0" : "#ff6b6b",
  });

  return (
    <div
      className="d-flex flex-row w-full step-6-container flex-wrap"
      style={{
        gap: "24px",
        alignItems: "stretch",
        paddingLeft: "16px",
        paddingRight: "16px",
        justifyContent: "center",
      }}
    >
      {/* Level Image Part */}
      <div className="step-6-image-wrapper">
        <LevelUpImage level={user.user_level ?? 0} />
      </div>
      {/* Stats Cards Part */}
      <div className="d-flex flex-column" style={{ minHeight: 0 }}>
        {/* --- Power Score Stats Section --- */}
        <div className="d-flex flex-column" style={{ marginBottom: "20px" }}>
          <h3
            className="text-heading-h3"
            style={{ color: "#C8CED3", marginBottom: "20px" }}
          >
            Power Score Stats
          </h3>

          <div className="row g-3" style={{ maxWidth: "755px" }}>
            {Object.entries(step6Data.powerScoreStats).map(([key, stat]) => {
              const trendValue = Number(
                String(stat.trend).replace(/[+%]/g, "") || 0,
              );

              const percentage = `${trendValue >= 0 ? "+" : ""}${trendValue}%`;

              return (
                <StatsCard
                  icon={getIcon(key)}
                  label={getLabel(key)}
                  score={stat.current}
                  total={stat.total}
                  percentage={percentage}
                  {...getTrendProps(trendValue)}
                  scoreColor="#e6ecf1"
                />
              );
            })}
          </div>
        </div>

        <div
          className="d-flex flex-column"
          style={{ marginBottom: "20px", maxWidth: "755px" }}
        >
          <h3
            className="text-heading-h3"
            style={{ color: "#C8CED3", marginBottom: "20px" }}
          >
            Average Life Scores
          </h3>

          {/* Use Bootstrap Row for consistent horizontal spacing and wrapping */}
          <div className="row g-3">
            {Object.entries(step6Data.averageLifeScores).map(([key, value]) => {
              return (
                // This wrapper ensures 3 items per row on large screens (lg)
                <div key={key} className="col-12 col-md-6 col-lg-4">
                  <LifeScoreCard
                    score={value}
                    label={getAverageScoreLabel(key)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
